import {
  ConsumerCategory,
  ConsumerCategoryInput,
  ParticipantInput,
  Timeslot,
} from '~types/appsync.types';
import { Participant } from '~types/participant';

import { parseDates } from './parseDates';

export function parseTimeslotsDates(timeslots?: ReadonlyArray<Timeslot> | null) {
  return (
    timeslots?.reduce((acc: Timeslot[], timeslot) => {
      acc.push(parseDates<Timeslot>(timeslot, ['date']));
      return acc;
    }, []) ?? []
  );
}

export function convertConsumerCategoryToConsumerCategoryInput(
  consumerCategory: ConsumerCategory,
): ConsumerCategoryInput {
  return {
    ageMax: `${consumerCategory.ageMax}`,
    ageMin: `${consumerCategory.ageMin}`,
    name: consumerCategory.name,
    shortname: consumerCategory.shortname,
    student: consumerCategory.student,
    visible: consumerCategory.visible,
  };
}

export function convertParticipantToParticipantInput(
  participant: Participant,
  productSlug: string,
  date: string,
): ParticipantInput {
  return {
    consumerCategory: convertConsumerCategoryToConsumerCategoryInput(participant.consumerCategory),
    date,
    id: participant.id,
    options: participant.options?.length
      ? participant.options.map((option) => ({
          slug: option.slug,
          timeslotExternalId: option.timeslot?.externalId,
        }))
      : [],
    productSlug,
    timeslotExternalId: participant.timeslotExternalId ?? undefined,
  };
}
